import { ethers } from 'ethers'
import { Buffer } from 'buffer'
export function shortAddress(address: string | `0x${string}` | undefined): string {
  if (address) {
    return `${address.slice(0, 6)}...${address.slice(address.length - 4)}`
  } else {
    return '0x0000...0000'
  }
}

export function isValidETHAddress(address: string): boolean {
  return ethers.utils.isAddress(address)
}

export function isValidSHA256(hashString: string): boolean {
  const regexExp = /^[a-f0-9]{64}$/gi

  let testString =
    hashString.length === 66 && hashString.slice(0, 2) === '0x' ? hashString.slice(2) : hashString

  return regexExp.test(testString)
}

export function getBase64(file: any) {
  return new Promise((resolve) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result as string)
    }
  })
}

export function stringToHex(str: string): string {
  return ethers.utils.hexlify(ethers.utils.toUtf8Bytes(str))
}

export function hexToString(hex: string): string {
  return ethers.utils.toUtf8String(hex)
}
